module.exports = __webpack_public_path__ + "img/312.f5b53f87.png";